import { BillingCodes } from "@/features/apcm-ops/components/BillingCodes"
import { useOrganizationsStore } from "@/stores/organizationsStore"

export default function BillingCodesPage() {
  const orgId = useOrganizationsStore((s) => s.selectedOrganizationId)

  if (!orgId) {
    return (
      <div className="flex items-center justify-center h-64 text-muted-foreground">
        Select an organization to view billing codes
      </div>
    )
  }

  return (
    <div className="mx-auto max-w-7xl space-y-6 p-4 md:p-8">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">
          Billing Codes
        </h1>
        <p className="text-sm text-muted-foreground mt-0.5">
          APCM G-code classifications by month of service. Download CSV for the billing team.
        </p>
      </div>
      <BillingCodes orgId={orgId} />
    </div>
  )
}
